import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  RefreshButton,
  CreateButton,
  ReferenceField
} from "admin-on-rest";
// Filter,
//   TextInput,
import { CardActions } from "material-ui/Card";
import { styles } from "../styles";
import "../index.css";
import IconTitle from "../../components/icon_title";
import CurrencyField from "../../components/CurrencyField";
import Pagination from "../../components/pagination";
import { TransferCreate as create, TransferEdit as edit } from "./Create";
import { getStatusTransfer } from "../utilsMarketer";

//import {MarketerCreate as create, MarketerEdit as edit, MarketerShow as show } from './Create';
export const TransferCreate = create;
export const TransferEdit = edit;

const TransfersActions = ({ resource, basePath, refresh }) => (
  <CardActions
    style={styles.cardActionStyleSmall}
    className="marketers-actions"
  >
    <CreateButton basePath={basePath} />
    <RefreshButton basePath={basePath} refresh={refresh} />
  </CardActions>
);
// const TransfersFilter = ({ ...props }) => (
//   <Filter {...props}>
//     <TextInput
//       label="resources.orders.actions.search"
//       source="search"
//       alwaysOn
//     />
//   </Filter>
// );

const StatusField = ({ record = {} }) => {
  let StatusName = getStatusTransfer(record.status);
  return <span>{StatusName}</span>;
};

const CurrencyField1 = ({ record = {} }) => (
  <CurrencyField
    hintText="Amount"
    underlineShow={false}
    precision={0}
    separator=""
    delimiter="."
    value={record.amount}
    unit="Rp"
  />
);
StatusField.defaultProps = { label: "Status" };

export const TransfersList = props => (
  <List
    {...props}
    actions={<TransfersActions />}
    title={
      <IconTitle
        icon="transfers"
        title={"resources.marketers.transfers.title"}
      />
    }
    pagination={<Pagination />}
  >
    <Datagrid bodyOptions={{ showRowHover: true }}>
      <ReferenceField
        label="resources.marketers.transfers.fields.first_name"
        source="user_id"
        reference="marketers"
        linkType={false}
      >
        <TextField
          label="resources.marketers.transfers.fields.first_name"
          source="first_name"
        />
      </ReferenceField>
      <ReferenceField
        label="resources.marketers.transfers.fields.last_name"
        source="user_id"
        reference="marketers"
        linkType={false}
      >
        <TextField
          label="resources.marketers.transfers.fields.last_name"
          source="last_name"
        />
      </ReferenceField>
      <CurrencyField1
        label="resources.marketers.transfers.fields.amount"
        source="amount"
      />
      <StatusField
        label="resources.marketers.transfers.fields.status"
        source="status"
      />
      <DateField
        label="resources.marketers.transfers.fields.create_at"
        source="created_at"
        showTime
      />
      <EditButton label="" style={{ textAlign: "right" }} />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/marketers/transfers/index.js